import { useEffect, useRef } from "react";
import RequestContactMultiSelect from "../RequestContactMultiSelect";
import { useGetprovidersListForProviderDetails } from "../../custom-hooks/queries";
import {
  CONTACT_CATEGORY,
  getDefaultApiContactsSelection,
  getRequestFormContacts,
} from "../../utils/requestContactDesignations";

/**
 * Vendor request contact(s) a sponsor picks on Request to Join: the same Assessment request
 * contacts the initial request offers, with the vendor's Primary preselected. Renders nothing
 * when the vendor has no eligible contacts.
 */
export default function JoinRequestContactsField({ providerId, value, onChange }) {
  const { data: providers } = useGetprovidersListForProviderDetails();
  const provider = (providers || []).find((p) => p?.provider_id === providerId);
  const contacts = getRequestFormContacts(provider, CONTACT_CATEGORY.ASSESSMENT);
  const preselected = useRef(false);

  useEffect(() => {
    if (preselected.current || contacts.length === 0) return;
    preselected.current = true;
    onChange(getDefaultApiContactsSelection(contacts));
  }, [contacts.length]); // eslint-disable-line react-hooks/exhaustive-deps

  if (contacts.length === 0) return null;

  return (
    <div className="w-full mt-4 text-left">
      <RequestContactMultiSelect
        contacts={contacts}
        selectedContacts={value}
        onChange={onChange}
        addNewContactOption={false}
      />
    </div>
  );
}
